export default __webpack_public_path__ + "static/media/Losttransmission.9d52a312.m4v";